import axios from "axios";
import queryString from 'query-string';
import './apiConfig';
import apiConfig from "./apiConfig";

const axiosClient = axios.create({
    baseURL: apiConfig.baseUrl,
    headers: {
        'content-type': 'application/json'
    },
    paramsSerializer: params => queryString.stringify({
        ...params,
        api_key: apiConfig.apiKey
    })
})

axiosClient.interceptors.request.use(async (config) => {
    //handle token
    return config;
})

axiosClient.interceptors.response.use((response) => {
    if(response && response.data){
        return response.data;
    }

    return response;
}, (error) => {
    throw error;
})

export default axiosClient;